<template>
  <div class="saveCard">
    <span>
      <img v-if="icon" :src="icon">
      {{ title }}
    </span>
    <div class="s_box">
      <div v-for="(item,index) in data" :key="item.sid" @click="openAppUrl(item)" v-if="data.length>0 && item.id">
        <div>
          <svg
            v-if="isImageOrSvg(typeof item.json =='object'?item.json.icon:'') === 0"
            t="1732605901531"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="4275"
            width="200"
            height="200"
          >
            <path
              d="M179.2 153.6a51.2 51.2 0 0 0-51.2 51.2v128a51.2 51.2 0 0 0 51.2 51.2h128a51.2 51.2 0 0 0 51.2-51.2V204.8a51.2 51.2 0 0 0-51.2-51.2H179.2z m0-102.4h128a153.6 153.6 0 0 1 153.6 153.6v128a153.6 153.6 0 0 1-153.6 153.6H179.2a153.6 153.6 0 0 1-153.6-153.6V204.8a153.6 153.6 0 0 1 153.6-153.6z m0 614.4a51.2 51.2 0 0 0-51.2 51.2v128a51.2 51.2 0 0 0 51.2 51.2h128a51.2 51.2 0 0 0 51.2-51.2V716.8a51.2 51.2 0 0 0-51.2-51.2H179.2z m0-102.4h128a153.6 153.6 0 0 1 153.6 153.6v128a153.6 153.6 0 0 1-153.6 153.6H179.2a153.6 153.6 0 0 1-153.6-153.6V716.8a153.6 153.6 0 0 1 153.6-153.6z m611.84-403.4048a51.2 51.2 0 0 0-72.3968 0L646.144 232.2432a51.2 51.2 0 0 0 0 72.3968l72.448 72.3968a51.2 51.2 0 0 0 72.3968 0l72.3968-72.3968a51.2 51.2 0 0 0 0-72.3968L791.04 159.744z m72.3968-72.3968l72.3968 72.3968a153.6 153.6 0 0 1 0 217.2416l-72.3968 72.3968a153.6 153.6 0 0 1-217.2416 0l-72.3968-72.3968a153.6 153.6 0 0 1 0-217.2416l72.3968-72.3968a153.6 153.6 0 0 1 217.2416 0zM699.7504 896a51.2 51.2 0 0 1 0 102.4A162.1504 162.1504 0 0 1 537.6 836.2496v-110.8992A162.1504 162.1504 0 0 1 699.7504 563.2h110.8992a162.1504 162.1504 0 0 1 162.1504 162.1504v8.448a51.2 51.2 0 0 1-102.4 0v-8.448c0-33.024-26.7264-59.7504-59.7504-59.7504h-110.8992c-33.024 0-59.7504 26.7264-59.7504 59.7504v110.8992c0 33.024 26.7264 59.7504 59.7504 59.7504z"
              fill="#2C6DD2"
              p-id="4276"
            ></path>
            <path
              d="M791.4496 160a51.2 51.2 0 0 0-72.3968 0l-72.448 72.3968a51.2 51.2 0 0 0 0 72.3968l72.448 72.3968a51.2 51.2 0 0 0 72.3968 0l72.3968-72.3968a51.2 51.2 0 0 0 0-72.3968l-72.3968-72.3968z"
              fill="#20C997"
              p-id="4277"
            ></path>
          </svg>
          <span
            v-if="isImageOrSvg(typeof item.json =='object'?item.json.icon:'') === 1"
            v-html="item.json.icon"
          ></span>
          <el-image
            v-if="isImageOrSvg(typeof item.json =='object'?item.json.icon:'') === 2"
            style="width: 100%; height: 100%"
            :src="item.json.icon"
            fit="cover"
          ></el-image>
        </div>
        <span>{{item.name}}</span>
      </div>
			<span v-if="data.length==0">暂无数据...</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "标题"
    },
    data: {
      type: Array,
      default: () => []
    },
		type:{
			type:Number,
			default:0
		},
    icon:{
      type:String,
      default:''
    }
  },
  data() {
    return {};
  },
  computed: {
    isImageOrSvg() {
      return value => {
        let _result = 0; //啥也不是
        if (value) {
          const svgPattern = /<svg.*<\/svg>/;
          const imagePattern = /\.(jpeg|jpg|gif|png|svg|bmp|webp)$/i; // 图片链接的正则表达式
          const urlPattern = /^(http|https):\/\/[^ "]+$/; // 网络地址的正则表达式

          if (svgPattern.test(value)) {
            _result = 1;
          } else if (urlPattern.test(value) && imagePattern.test(value)) {
            _result = 2;
          }
        }
        return _result;
      };
    }
  },
	methods: {
		openAppUrl(item){
			this.$emit("saveClick",item,this.type)
			// window.open(item.url, "_blank");
		}
	},
};
</script>

<style scoped>
.saveCard {
  width: 100%;
  height: auto;
  margin-bottom: 10px;
  box-sizing: border-box;
  padding: 10px;
}

.saveCard > span {
  font-size: 16px;
  font-weight: 400;
  display: flex;
  color: #00000066;
  align-items: center;
  margin-left: 0px;
}

.saveCard >span >img{
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

.s_box {
  width: 100%;
  height: auto;
	padding-top: 15px;
}

.s_box>div{
	width: 100%;
	height: 30px;
  margin-top: 10px;
	margin-bottom: 15px;
	display: flex;
	align-items: center;
	border-radius: 5px;
	cursor: pointer;
	transition: .1s;
}

/* .s_box>div:hover{
	background-color: aliceblue;
} */

.s_box>div>div{
	width: 22px;
	height: 22px;
	box-sizing: border-box;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 10px;
  margin-left: 15px;
}

.s_box>div>div>svg{
	width: 100%;
	height: 100%;
}

.s_box>div>div>span>>>svg{
	width: 100%;
	height: 100%;
}


.s_box>div>span{
	max-width: calc(100% - 46px);
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
  font-size: 16px;
  font-weight: 400;
  color: #000000E5;
}

.s_box>span{
	font-size: .8em;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/appStore/components/saveCard.vue